<template>
    <v-container fluid>
        <h2 class="subheading grey--text">{{$t('entrada_salida_no_code')}}</h2>
        <v-dialog v-model="dialog_cellphone" max-width="290">
            <v-card class="justify-center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('aviso')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text class="text-xs-center">
                    <v-icon medium color="warning">warning</v-icon>
                    {{$t('cellphone_wrong')}}
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="primary" @click="dialog_cellphone = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSendAccessCode" max-width="400px">
            <v-card class="justify-center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('access_code')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text class="text-xs-center">
                    <v-icon x-large color="primary">qr_code</v-icon><br>
                    {{$t('access_code_elevator')}}
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            v-if="bandSMS === true"
                            color="primary"
                            block
                            @click="setAccessCodeSMS()"
                    >
                        <v-icon>textsms</v-icon>
                        {{$t('enviar_codigo')}} {{$t('by_SMS')}}
                    </v-btn>
                    <v-btn
                            v-if="bandPrint === true"
                            color="primary"
                            block
                            @click="download_gafete()"
                    >
                        <v-icon>print</v-icon>
                        {{$t('print_name_tag')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Diálogo modal Persistente para seleccionar la Caseta -->
        <v-dialog v-model="dialogInicio" persistent max-width="400px">
            <v-form @submit.prevent="setCaseta()">
                <v-card class="justify-center">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('selecciona_caseta')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-autocomplete
                                v-model="caseta"
                                name="caseta"
                                :items="casetas"
                                item-text="name"
                                item-value="id"
                                return-object
                                :label="$t('Casetas')"
                                :loading="loading"
                        ></v-autocomplete>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                type="submit"
                        >{{ $t('agregar') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-card
                width="900"
                class="mx-auto elevation-7"
        >
            <v-toolbar dark color="primary">
                <v-toolbar-title>
                    {{$t('entrada_salida_no_code')}}
                </v-toolbar-title>
            </v-toolbar>
            <v-tabs v-model="activeTab">
                <!-- Tab 1: Acceso sin Código -->
                <v-tab>
                    <v-icon left>person</v-icon>
                    Acceso sin Código
                </v-tab>

                <!-- Tab 2: Proveedores Externos -->
                <v-tab>
                    <v-icon left>business</v-icon>
                    Proveedores Externos
                </v-tab>

                <!-- Contenido Tab 1: Acceso sin Código -->
                <v-tab-item>
                    <v-card-text>
                        <v-layout  row wrap class="text-xs-center">
                            <v-flex>
                                <p class="text-xs-center">{{$t('msg_access_no_code')}}</p>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="text-xs-center">
                    <v-flex xs6>
                        <v-layout justify-center class="text-xs-center edge pt-3 pb-3 pl-3 pr-3" row wrap>
                            <v-flex xs12>
                                <h3>{{$t('select_video_device')}}  </h3>
                                <select v-model="camera">
                                    <option>{{$t('select_video_device')}}</option>
                                    <option
                                            v-for="device in devices"
                                            :key="device.deviceId"
                                            :value="device.deviceId">
                                        {{ device.label }}
                                    </option>
                                </select>
                                <v-img
                                        width="100%"
                                        :src="img !== '' ? img : require('../../assets/sin-foto.png')"
                                >
                                    <v-layout row wrap>
                                        <v-flex class="text-xs-left">
                                            <v-avatar
                                                    class="profile"
                                                    color="grey"
                                                    size="164"
                                                    tile
                                            >
                                                <div v-show="band" @click="onCapture()">
                                                    <vue-web-cam
                                                            ref="webcam"
                                                            :device-id="deviceId"
                                                            width="100%"
                                                            @started="onStarted"
                                                            @stopped="onStopped"
                                                            @error="onError"
                                                            @cameras="onCameras"
                                                            @camera-change="onCameraChange"
                                                    />
                                                </div>
                                            </v-avatar>
                                        </v-flex>
                                    </v-layout>
                                </v-img>
                            </v-flex>
                            <br>
                            <v-alert
                                    :value="errores.photo"
                                    color="error"
                                    icon="warning"
                                    outline
                            >
                                {{errores.photo}}
                            </v-alert>
                            <br>
                            {{$t('msg_captura_foto')}}
                        </v-layout>
                    </v-flex>
                    <v-flex xs6 class="text-xs-center pt-3 pb-3 pl-3 pr-3">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-autocomplete
                                        v-model="idCompany"
                                        prepend-icon="person"
                                        name="idCompany"
                                        :item-text="example"
                                        item-value="id"
                                        :label="$t('Empresa')"
                                        :filter="customFilter"
                                        :error-messages="errores.idCompany"
                                        :items="companiesByPark"
                                        :no-data-text="$t('no_resultados')"
                                        autocomplete="off"
                                        clearable
                                ></v-autocomplete>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field
                                        v-model="first_name"
                                        prepend-icon="person"
                                        name="first_name"
                                        :label="$t('Nombre')"
                                        :error-messages="errores.name_guest"
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field
                                        v-model="last_name"
                                        prepend-icon="person_outline"
                                        name="last_name"
                                        :label="$t('Apellido')"
                                        :error-messages="errores.name_guest"
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-flex xs12>
                            <v-checkbox
                                    v-model="bandCelular"
                                    :label="$t('celular')"
                            >
                            </v-checkbox>
                        </v-flex>
                        <v-flex xs12>
                            <vue-phone-number-input
                                    v-if="bandCelular === true"
                                    default-country-code="MX"
                                    color="#D32F2F"
                                    valid-color="#2196F3"
                                    @update="onChange"
                                    v-model="cellNumber"
                                    :translations="custom_cell_phone"
                            >
                            </vue-phone-number-input>
                        </v-flex>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field
                                        v-model="comentarios"
                                        prepend-icon="notes"
                                        name="comentarios"
                                        :label="$t('comentarios')"
                                        :error-messages="errores.comments"
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-alert
                                :value=alerta
                                type="warning"
                                outline
                                transition="scale-transition"
                        >
                            Fallo con el Servidor
                        </v-alert>
                    </v-flex>
                </v-layout>
                <div align="center">
                    <v-btn
                            large
                            color="primary"
                            @click="createAccessWithoutCode()"
                            :loading="loading"
                    >{{$t('enviar')}}
                    </v-btn>
                </div>
                    </v-card-text>
                </v-tab-item>

                <!-- Contenido Tab 2: Proveedores Externos -->
                <v-tab-item>
                    <v-card-text>
                        <v-layout row wrap class="text-xs-center">
                            <v-flex>
                                <p class="text-xs-center">Registro de Proveedores Externos</p>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="text-xs-center">
                            <!-- Columna Izquierda: Captura de Foto INE -->
                            <v-flex xs6>
                                <v-layout justify-center class="text-xs-center edge pt-3 pb-3 pl-3 pr-3" row wrap>
                                    <v-flex xs12>
                                        <h3>Fotografía de INE</h3>
                                        <div v-if="providerFound" class="mb-2">
                                            <strong class="primary--text">{{ currentProvider.firstName }} {{ currentProvider.lastName }}</strong>
                                        </div>
                                        <v-img
                                            width="100%"
                                            :src="inePhotoBase64 !== '' ? inePhotoBase64 : require('../../assets/sin-foto.png')"
                                        >
                                            <v-layout row wrap>
                                                <v-flex class="text-xs-left">
                                                    <v-avatar
                                                        class="profile"
                                                        color="grey"
                                                        size="164"
                                                        tile
                                                    >
                                                        <div v-show="band && !providerFound" @click="captureInePhoto()">
                                                            <vue-web-cam
                                                                ref="ineWebcam"
                                                                :device-id="deviceId"
                                                                width="100%"
                                                                @started="onIneStarted"
                                                                @stopped="onIneStopped"
                                                            />
                                                        </div>
                                                    </v-avatar>
                                                </v-flex>
                                            </v-layout>
                                        </v-img>
                                    </v-flex>
                                    <br>
                                    <v-alert
                                        v-if="providerFound"
                                        type="success"
                                        icon="check_circle"
                                        outline
                                    >
                                        Foto cargada automáticamente
                                    </v-alert>
                                    <v-alert
                                        v-else-if="inePhotoBase64 === ''"
                                        color="warning"
                                        icon="warning"
                                        outline
                                    >
                                        Capturar Fotografía de INE
                                    </v-alert>
                                    <div v-if="!providerFound">
                                        <br>
                                        Haz click en la cámara para capturar la foto
                                    </div>
                                </v-layout>
                            </v-flex>

                            <!-- Columna Derecha: Formulario -->
                            <v-flex xs6 class="text-xs-center pt-3 pb-3 pl-3 pr-3">
                                <!-- Alert de Feedback -->
                                <v-alert
                                    v-if="showFeedback"
                                    :type="feedbackType"
                                    :icon="feedbackType === 'success' ? 'check_circle' : feedbackType === 'error' ? 'error' : 'info'"
                                    dismissible
                                    class="my-2"
                                    @input="showFeedback = false"
                                >
                                    {{ feedbackMessage }}
                                </v-alert>

                                <!-- Búsqueda de Proveedor con Autocomplete -->
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-autocomplete
                                            v-model="selectedProviderId"
                                            :items="providerSearchResults"
                                            item-text="display_name"
                                            item-value="id"
                                            :search-input.sync="providerSearchName"
                                            :loading="loadingSearchProvider"
                                            :disabled="providerFound"
                                            prepend-icon="person_search"
                                            label="Buscar Proveedor"
                                            placeholder="Escribe nombre (ej: O, Ju, Juan)"
                                            no-data-text="No hay resultados"
                                            clearable
                                            @change="onProviderSelected"
                                        >
                                            <template v-slot:item="data">
                                                <div class="text-left" style="width: 100%;">
                                                    <strong>{{ data.item.first_name }} {{ data.item.last_name }}</strong>
                                                    <div class="grey--text caption" v-if="data.item.servicios && data.item.servicios.length > 0">
                                                        Servicios: {{ data.item.servicios.map(s => s.name).join(', ') }}
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-slot:selection="data">
                                                <span class="text-truncate">{{ data.item.first_name }} {{ data.item.last_name }}</span>
                                            </template>
                                        </v-autocomplete>
                                    </v-flex>
                                </v-layout>

                                <!-- Estado del Proveedor -->
                                <v-alert
                                    v-if="providerFound"
                                    type="success"
                                    icon="check_circle"
                                    outline
                                    class="my-2"
                                >
                                    Proveedor existente - Datos pre-cargados
                                </v-alert>
                                <v-alert
                                    v-if="providerSearchName && !providerFound && !loadingSearchProvider"
                                    type="info"
                                    icon="add_circle"
                                    outline
                                    class="my-2"
                                >
                                    Proveedor nuevo - Completa los datos
                                </v-alert>

                                <!-- Campos de Nombre y Apellido (Siempre visibles) -->
                                <v-divider class="my-3"></v-divider>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="currentProvider.firstName"
                                            prepend-icon="person"
                                            label="Nombre"
                                            :disabled="providerFound"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="currentProvider.lastName"
                                            prepend-icon="person_outline"
                                            label="Apellido"
                                            :disabled="providerFound"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <!-- Selector de Empresas (Múltiple) -->
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-select
                                            v-model="selectedCompanies"
                                            :items="companiesByPark"
                                            item-text="name"
                                            item-value="id"
                                            label="Seleccione Empresa(s)"
                                            multiple
                                            chips
                                            prepend-icon="business"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>

                                <!-- Selector de Servicio -->
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-select
                                            v-model="selectedService"
                                            :items="servicios"
                                            item-text="name"
                                            item-value="id"
                                            label="Servicio a Realizar"
                                            prepend-icon="build"
                                            :loading="loadingServicios"
                                            outlined
                                            dense
                                        >
                                            <template v-slot:item="data">
                                                <div style="width: 100%; padding: 8px 0;">
                                                    <strong>{{ data.item.name }}</strong>
                                                    <div class="grey--text" style="font-size: 12px; margin-top: 4px;">{{ data.item.description }}</div>
                                                </div>
                                            </template>
                                        </v-select>
                                    </v-flex>
                                </v-layout>

                                <!-- Información del Vehículo -->
                                <v-divider class="my-3"></v-divider>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="placas"
                                            prepend-icon="directions_car"
                                            label="Placas del Vehículo (Opcional)"
                                            placeholder="Ej: ABC-1234"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tracticamion"
                                            prepend-icon="local_shipping"
                                            label="Tractor/Unidad (Opcional)"
                                            placeholder="Ej: Volvo FH16-2022"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="observaciones"
                                            prepend-icon="note"
                                            label="Observaciones (Opcional)"
                                            placeholder="Ej: Entrega de materiales para construcción"
                                            outlined
                                            dense
                                            rows="2"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>

                                <!-- Botón de Acceso -->
                                <v-layout row wrap>
                                    <v-flex xs12 class="text-xs-center">
                                        <v-btn
                                            color="success"
                                            large
                                            @click="registerExternalProviderAccess"
                                            :loading="loadingProviderAccess"
                                            :disabled="selectedCompanies.length === 0 || !inePhotoBase64 || !selectedService"
                                            block
                                        >
                                            <v-icon left>check_circle</v-icon>
                                            Registrar Acceso
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </v-container>
</template>

<script>
    import jsPDF from 'jspdf'
    import { WebCam } from "vue-web-cam"
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import { mapState } from 'vuex'
    import VuePhoneNumberInput from 'vue-phone-number-input'
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'

    Vue.component('vue-phone-number-input', VuePhoneNumberInput)
    Vue.use(VeeValidate)

    export default {
        name: "access_no_code",
        components: {
            "vue-web-cam": WebCam
        },
        data() {
            return {
                img: '',
                camera: null,
                deviceId: null,
                devices: [ ],
                idEmpresa: '',
                first_name: '',
                last_name: '',
                comentarios: '',
                errores: [],
                companies: [],
                loading: false,
                alerta: '',
                dialogInicio: false,
                casetas: [],
                caseta: 0,
                band: false,
                companiesByPark: [],
                idCompany: null,
                bandCelular: false,
                cellNumber: '',
                band_cellphone: false,
                dialog_cellphone: false,
                cellphone_plus_country_code: '',
                custom_cell_phone: { },
                loading_gafete: false,
                dialogSendAccessCode: false,
                bandPrint: false,
                bandSMS: false,
                numPiso: -1,
                // ===== Nuevas propiedades para Proveedores Externos =====
                activeTab: 0,
                // Búsqueda de proveedor
                providerSearchName: '',
                providerSearchResults: [],
                selectedProviderId: null,
                loadingSearchProvider: false,
                providerFound: false,
                currentProvider: {
                    id: null,
                    firstName: '',
                    lastName: '',
                    inePhoto: ''
                },
                // Captura de foto INE
                inePhotoBase64: '',
                // Empresas seleccionadas
                selectedCompanies: [],
                loadingProviderAccess: false,
                // Catálogo de servicios
                servicios: [],
                loadingServicios: false,
                selectedService: null,
                // Información del vehículo
                placas: '',
                tracticamion: '',
                observaciones: '',
                // Feedback de acceso
                feedbackMessage: '',
                feedbackType: '', // 'success', 'error', 'info'
                showFeedback: false
            };
        },
        computed: {
            ...mapState(['language']),
            device () {
                return this.devices.find(n => n.deviceId === this.deviceId)
            }
        },
        created: function(){
          this.getCurrentDate()
            // Obtener Empresas dentro del Parque
            this.getCompaniesByPark()
            this.getCasetas()
            // Obtener Catálogo de Servicios
            this.getServicios()
            if(localStorage.getItem('id_caseta') === null){
                this.dialogInicio = true
            }
        },
        beforeUpdate (){
            this.custom_cell_phone ={
              "countrySelectorLabel": this.$t('codigo_pais'),
              "phoneNumberLabel": this.$t('celular'),
              "example": this.$t('ejemplo')
            }
        },
        watch: {
            camera: function(id) {
                this.deviceId = id;
            },
            devices () {
                // Once we have a list select the first one
                const [first, ...tail] = this.devices
                if (first) {
                    this.camera = first.deviceId
                    this.deviceId = first.deviceId
                }else {
                    this.camera = tail.deviceId
                    this.deviceId = tail.deviceId
                }
            },
            providerSearchName (val) {
                // Buscar mientras escribe (si tiene al menos 1 letra)
                if (val && val.trim().length > 0) {
                    this.searchProvider(val);
                } else {
                    this.providerSearchResults = [];
                }
            }
        },
        methods: {
            onCapture() {
                this.img = this.$refs.webcam.capture()
            },
            onStarted(stream) {
                console.log('Inicio')
                this.band = true
                console.log("On Started Event", stream)
                console.log('Fin')
            },
            onStopped(stream) {
                console.log("On Stopped Event", stream)
            },
            onStop() {
                this.$refs.webcam.stop()
            },
            onStart() {
                // console.log('Inicio')
                this.$refs.webcam.start()
                // console.log('Fin')
            },
            onError(error) {
                console.log("On Error Event", error)
            },
            onCameras(cameras) {
                this.devices = cameras
                console.log("On Cameras Event", cameras)
            },
            onCameraChange(deviceId) {
                this.deviceId = deviceId
                this.camera = deviceId
                console.log("On Camera Change Event", deviceId)
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], filename, {type:mime})
            },
            loadImageAsBase64(imageUrl) {
                if (!imageUrl) {
                    console.warn('No se proporcionó URL de imagen');
                    return;
                }

                console.log('📸 Intentando cargar imagen desde:', imageUrl);

                const img = new Image();
                img.crossOrigin = 'anonymous';

                img.onload = () => {
                    console.log('✅ Imagen cargada exitosamente');
                    try {
                        const canvas = document.createElement('canvas');
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0);
                        const base64Data = canvas.toDataURL('image/jpeg');
                        this.$set(this, 'inePhotoBase64', base64Data);
                        console.log('✅ Imagen convertida a base64 y actualizada');
                    } catch (err) {
                        console.error('❌ Error al convertir imagen a base64:', err);
                    }
                };

                img.onerror = (error) => {
                    console.error('❌ Error cargando imagen:', imageUrl, error);
                    // Intentar sin crossOrigin si falla
                    img.crossOrigin = '';
                    img.src = imageUrl;
                };

                img.src = imageUrl;
            },
            onChange (data) {
                this.cellphone_plus_country_code = data.e164
                this.band_cellphone = data.isValid
            },
            createAccessWithoutCode () {
              if(this.bandCelular === true && this.band_cellphone === true) {
                this.loading = true
                this.errores = []
                console.log('Access Without Code Created ....Caso 1')
                var bodyFormData = new FormData()
                var fileImageFront = null
                const newID = this.$uuid.v4()
                bodyFormData.set('name_guest', this.first_name + ' ' + this.last_name)
                bodyFormData.set('comments', this.comentarios)
                bodyFormData.set('guardhouse', localStorage.getItem('id_caseta'))
                bodyFormData.set('park', localStorage.getItem('id_parque'))
                bodyFormData.set('idCompany', this.idCompany)
                if (this.bandCelular === true)
                    bodyFormData.set('cellNumber', this.cellphone_plus_country_code)

                if (this.img !== '' && this.img.length > 6) {
                    fileImageFront = this.dataURLtoFile(this.img, 'photo' + newID + '.jpeg')
                }
                bodyFormData.append('photo', fileImageFront)
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/AccessParkNoCode/createList/',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Accept-Language': this.language,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: bodyFormData
                }
                axios(config)
                    .then(ok => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
                        let dataCompanyAux = this.getDataCompany(this.idCompany)
                        if (dataCompanyAux.numPiso !== null) {
                            this.bandSMS = true
                            this.bandPrint = true
                            this.numPiso = dataCompanyAux.numPiso
                            this.dialogSendAccessCode = true
                        } else {
                            setTimeout(this.clear, 3000)
                        }
                    })
                    .catch(error => {
                        this.loading = false
                        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
                            this.errores = error.response.data
                        }
                    })
              } else if (this.bandCelular === false) {
                this.loading = true
                this.errores = []
                console.log('Access Without Code Created ....Caso 2')
                var bodyFormData = new FormData()
                var fileImageFront = null
                const newID = this.$uuid.v4()
                bodyFormData.set('name_guest', this.first_name + ' ' + this.last_name)
                bodyFormData.set('comments', this.comentarios)
                bodyFormData.set('guardhouse', localStorage.getItem('id_caseta'))
                bodyFormData.set('park', localStorage.getItem('id_parque'))
                bodyFormData.set('idCompany', this.idCompany)

                if (this.img !== '' && this.img.length > 6) {
                    fileImageFront = this.dataURLtoFile(this.img, 'photo' + newID + '.jpeg')
                }
                bodyFormData.append('photo', fileImageFront)
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/AccessParkNoCode/createList/',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Accept-Language': this.language,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: bodyFormData
                }
                axios(config)
                    .then(ok => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
                        let dataCompanyAux = this.getDataCompany(this.idCompany)
                        if (dataCompanyAux.numPiso !== null) {
                            this.numPiso = dataCompanyAux.numPiso
                            this.bandSMS = false
                            this.bandPrint = true
                            this.dialogSendAccessCode = true
                        } else {
                            setTimeout(this.clear, 3000)
                        }
                    })
                    .catch(error => {
                        this.loading = false
                        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
                            this.errores = error.response.data
                        }
                    })
              } else {
                    this.dialog_cellphone = true
              }
            },
            clear: function () {
                this.alerta = false
                this.errores = []
                this.$validator.reset()
                this.$store.commit('snackbar_activate_false')
                this.cleanFields()
            },
            cleanFields(){
                this.img = ''
                this.idCompany = ''
                this.first_name = ''
                this.last_name = ''
                this.comentarios = ''
                this.bandCelular = false
                this.cellNumber = ''
                this.band_cellphone = false
                this.cellphone_plus_country_code = ''
                this.bandPrint = false,
                this.bandSMS = false
                this.numPiso = -1
            },
            getCompanies: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.companies = response.data
                        console.log(this.companies)
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            getCompaniesByPark (){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/parques/empresas',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.companiesByPark = response.data
                        console.log('Empresas = ', this.companies)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            customFilterArea (item, queryText) {
                const textOne = item.nombre.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
            },
            customFilter (item, queryText) {
                const textOne = item.name.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1

            },
            example: item => item.name,
            setCaseta: function(){
                if(this.caseta.id > 0){
                    // Intentar obtener park de diferentes propiedades
                    const parkId = this.caseta.park
                        || this.caseta.parque_id
                        || this.caseta.parkId
                        || this.caseta.id_parque;

                    if (!parkId) {
                        console.error('❌ No se encontró parque_id en ninguna propiedad de caseta:', this.caseta);
                        this.$store.commit('snackbar_activate_true');
                        this.$store.commit('snackbar_change_message', 'Error: La caseta no tiene parque asociado');
                        return;
                    }

                    localStorage.setItem('id_caseta', this.caseta.id);
                    localStorage.setItem('id_parque', parkId);
                    this.dialogInicio = false;
                }
            },
            getCasetas: function(){
                this.loading = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/GuardHouse/ListCreate/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.casetas = response.data
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            getImgFromUrl(logo_url, callback) {
                var img = new Image();
                img.src = logo_url;
                img.onload = function () {
                    callback(img);
                };
            },
            xOffset (pdf, text) {
                return(
                    pdf.internal.pageSize.width / 2)
                    - (pdf.getStringUnitWidth(text)
                        * pdf.internal.getFontSize() / 2)
            },
            getDataCompany(idCompany) {
              let res =  []
              for (let i = 0; i< this.companiesByPark.length; i++) {
                if(this.companiesByPark[i].id === idCompany) {
                  res = this.companiesByPark[i]
                }
              }
              return res
            },
            download_gafete() {
                this.loading_gafete = true
                const toDataUrl = (url, callback) => {
                    const xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            callback(reader.result);
                        };
                        reader.readAsDataURL(xhr.response);
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                };

                toDataUrl('https://api.qrserver.com/v1/create-qr-code/?data=' + this.createAccesCodeElevator(this.numPiso) + '&ecc=M&margin=20&size=400x400', (myBase64) => {
                    var pdf = new jsPDF("portrait", "pt", "letter")
                    // Black square with rounded corners
                    pdf.setDrawColor(0)
                    pdf.setFillColor(255, 255, 255)
                    pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
                    pdf.setFontStyle("bold")
                    pdf.text('Código de Acceso',
                        this.xOffset(pdf, 'Código de Acceso'),
                        140)
                    pdf.setFontStyle("normal")
                    pdf.text('Elevador',
                        this.xOffset(pdf, 'Elevador'),
                        170)
                    pdf.setFontStyle("normal")
                    pdf.setFontSize(8)
                    pdf.text('Escanea este código en el lector de QR del Elevador.',
                        this.xOffset(pdf, 'Escanea este código en el lector de QR del Elevador.'),
                        220)
                    pdf.text('Este código caducará en 15 minutos.',
                        this.xOffset(pdf, 'Este código caducará en 15 minutos.'),
                        435)
                    // console.log(myBase64); // myBase64 is the base64 string
                    pdf.addImage(myBase64, 'WEBP', 215, 240, 180, 180)
                    let dataCompany = this.getDataCompany(this.idCompany)
                    if(dataCompany.length !== 0) {
                        if (dataCompany.logo === null || dataCompany.logo === '')
                        {
                            this.getImgFromUrl(require('../../assets/intrare_logo.png'), function (logo_system,) {
                               pdf.addImage(logo_system, 'WEBP', 370, 60, 50, 50)
                               pdf.save('gafete.pdf')
                            })
                        } else {
                            toDataUrl(dataCompany.logo, (logo_guest) => {
                                pdf.addImage(logo_guest, 'WEBP', 190, 60, 50, 50)
                                this.getImgFromUrl(require('../../assets/intrare_logo.png'), function (logo_system,) {
                                   pdf.addImage(logo_system, 'WEBP', 370, 60, 50, 50)
                                   pdf.save('gafete.pdf')
                                })
                            })
                        }
                    }
                    this.loading_gafete = false
                    this.clear()
                    this.dialogSendAccessCode = false
                });
            },
            getCurrentDate (){
                var today = new Date()
                var dd = today.getDate()
                var mm = today.getMonth() + 1
                var yyyy = today.getFullYear()
                if(dd<10)
                {
                    dd='0'+dd
                }
                if(mm<10)
                {
                    mm='0'+mm
                }
                var h = (today.getHours() < 10 ? '0' : '') + today.getHours()
                var m = (today.getMinutes() < 10 ? '0' : '') + today.getMinutes()

                var res = yyyy.toString() + mm.toString() + dd.toString() + h.toString() + m.toString()
                console.log(res)
                return res
            },
            createAccesCodeElevator (numPiso) {
              let cadenaAux = Math.random().toString(36).substring(7)
              return btoa(this.getCurrentDate() + ',10,' + numPiso.toString() + ',-1' + ',' + cadenaAux)
            },
            setAccessCodeSMS() {
              // Generar el Código de Acceso del Elevador
              const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/AccessParkNoCode/sendAccessCodeElevator/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        cellNumber: this.cellphone_plus_country_code,
                        // Generar Código
                        code: this.createAccesCodeElevator(this.numPiso)
                    }
                }
                axios(config)
                    .then(ok => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_success_sms'))
                    })
                    .catch(error => {
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })
              this.clear()
              this.dialogSendAccessCode = false
            },
        getServicios() {
            this.loadingServicios = true;
            const config = {
                method: 'GET',
                url: 'https://empresa-service.intrare.app/servicios-catalogo/',
                headers: {
                    'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    this.servicios = response.data;
                    this.loadingServicios = false;
                })
                .catch(error => {
                    console.error('Error cargando servicios:', error);
                    // Fallback: servicios hardcodeados
                    this.servicios = [
                        { id: 1, name: 'Electricista', description: 'Servicio de electricidad' },
                        { id: 2, name: 'Plomero', description: 'Servicio de plomería' }
                    ];
                    this.loadingServicios = false;
                });
        },
        searchProvider(searchText) {
            const searchTerm = searchText || this.providerSearchName;

            if (!searchTerm || !searchTerm.trim()) {
                this.providerSearchResults = [];
                return;
            }

            const parkId = localStorage.getItem('id_parque');

            // Validar que tenemos el parque_id
            if (!parkId) {
                console.error('No hay parque_id en localStorage');
                this.providerSearchResults = [];
                return;
            }

            this.loadingSearchProvider = true;

            const config = {
                method: 'get',
                url: `https://empresa-service.intrare.app/proveedores/search?nombre=${encodeURIComponent(searchTerm)}&parque_id=${parkId}`,
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                }
            };

            axios(config)
                .then(response => {
                    if (Array.isArray(response.data) && response.data.length > 0) {
                        // Múltiples resultados encontrados
                        this.providerSearchResults = response.data.map(provider => ({
                            ...provider,
                            display_name: `${provider.first_name} ${provider.last_name}`
                        }));

                        console.log(`✅ ${response.data.length} proveedor(es) encontrado(s)`, response.data);

                        // Mostrar feedback
                        this.feedbackMessage = `✅ Se encontraron ${response.data.length} proveedor(es). Selecciona uno de la lista.`;
                        this.feedbackType = 'info';
                        this.showFeedback = true;
                    } else {
                        // Sin resultados - permitir crear nuevo proveedor
                        this.providerSearchResults = [];
                        this.currentProvider = {
                            id: null,
                            firstName: searchTerm.split(' ')[0],
                            lastName: searchTerm.split(' ').slice(1).join(' '),
                            inePhoto: ''
                        };
                        this.providerFound = false;

                        console.log('ℹ️ No se encontraron proveedores. Permitir crear nuevo.');

                        // Mostrar feedback
                        this.feedbackMessage = `ℹ️ No se encontraron proveedores con "${searchTerm}". Puedes crear uno nuevo completando los datos.`;
                        this.feedbackType = 'info';
                        this.showFeedback = true;
                    }
                    this.loadingSearchProvider = false;
                })
                .catch(error => {
                    console.error('❌ Error buscando proveedores:', error);
                    this.providerSearchResults = [];

                    // Mostrar feedback de error
                    const errorMsg = error.response && error.response.data && error.response.data.detail
                        ? error.response.data.detail
                        : error.message;

                    this.feedbackMessage = `❌ Error al buscar: ${errorMsg}`;
                    this.feedbackType = 'error';
                    this.showFeedback = true;

                    this.loadingSearchProvider = false;
                });
        },
        onProviderSelected(providerId) {
            // Se ejecuta cuando el usuario selecciona un proveedor de la lista
            console.log('👤 Proveedor seleccionado ID:', providerId);

            if (!providerId) {
                this.providerFound = false;
                this.currentProvider = {
                    id: null,
                    firstName: '',
                    lastName: '',
                    inePhoto: ''
                };
                this.inePhotoBase64 = '';
                return;
            }

            // Buscar el proveedor seleccionado en los resultados
            const selected = this.providerSearchResults.find(p => p.id === providerId);
            console.log('🔍 Proveedor encontrado:', selected);

            if (selected) {
                this.currentProvider = {
                    id: selected.id,
                    firstName: selected.first_name,
                    lastName: selected.last_name,
                    inePhoto: selected.ine_photo
                };
                this.providerFound = true;

                // Cargar la foto del INE si existe
                console.log('📸 URL de foto disponible:', selected.ine_photo);
                if (selected.ine_photo) {
                    console.log('⏳ Iniciando carga de imagen...');
                    this.loadImageAsBase64(selected.ine_photo);
                } else {
                    console.warn('⚠️ Sin URL de foto para este proveedor');
                }

                // Mostrar feedback de selección
                this.feedbackMessage = `✅ Proveedor seleccionado: ${selected.first_name} ${selected.last_name}`;
                this.feedbackType = 'info';
                this.showFeedback = true;

                console.log('✅ Proveedor cargado:', selected);

                // Auto-cerrar el alert después de 3 segundos
                setTimeout(() => {
                    this.showFeedback = false;
                }, 3000);
            }
        },
        resetProviderSearch() {
            this.providerSearchName = '';
            this.currentProvider = {
                id: null,
                firstName: '',
                lastName: '',
                inePhoto: ''
            };
            this.providerFound = false;
            this.selectedCompanies = [];
            this.inePhotoBase64 = '';
            this.selectedService = null;
            this.placas = '';
            this.tracticamion = '';
            this.observaciones = '';
        },
        captureInePhoto() {
            if (this.$refs.ineWebcam) {
                this.inePhotoBase64 = this.$refs.ineWebcam.capture();
            }
        },
        onIneStarted() {
            console.log('INE camera started');
        },
        onIneStopped() {
            console.log('INE camera stopped');
        },
        registerExternalProviderAccess() {
            if (this.selectedCompanies.length === 0 || !this.inePhotoBase64 || !this.selectedService) {
                return;
            }

            const parkId = localStorage.getItem('id_parque');
            const casetaId = localStorage.getItem('id_caseta');

            // Validar que tenemos los datos requeridos
            if (!parkId) {
                this.$store.commit('snackbar_activate_true');
                this.$store.commit('snackbar_change_message', 'Error: Por favor selecciona una caseta primero');
                console.error('No hay parque_id en localStorage');
                return;
            }

            if (!casetaId) {
                this.$store.commit('snackbar_activate_true');
                this.$store.commit('snackbar_change_message', 'Error: No se encontró la caseta');
                console.error('No hay caseta_id en localStorage');
                return;
            }

            this.loadingProviderAccess = true;

            // Registrar acceso para cada empresa seleccionada
            const accessPromises = this.selectedCompanies.map(companyId => {
                const formData = new FormData();
                const inePhotoFile = this.dataURLtoFile(this.inePhotoBase64, 'ine_photo.jpeg');

                // Escenario 1: Proveedor ya existe
                if (this.currentProvider.id) {
                    formData.append('proveedor_id', this.currentProvider.id);
                } else {
                    // Escenario 2: Proveedor NO existe (se crea automáticamente)
                    formData.append('parque_id', parkId);
                    formData.append('first_name', this.currentProvider.firstName);
                    formData.append('last_name', this.currentProvider.lastName);
                    formData.append('servicios_ids', this.selectedService);
                }

                // Campos comunes
                formData.append('ine_photo_entrada', inePhotoFile);
                formData.append('caseta_id', casetaId);
                formData.append('empresa_id', companyId);
                formData.append('service_id', this.selectedService);
                formData.append('fecha', new Date().toISOString().split('T')[0]);
                formData.append('hora', new Date().toTimeString().split(' ')[0]);

                // Información del vehículo (opcional)
                if (this.placas) {
                    formData.append('placas', this.placas);
                }
                if (this.tracticamion) {
                    formData.append('tracticamion', this.tracticamion);
                }
                if (this.observaciones) {
                    formData.append('observaciones', this.observaciones);
                }

                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/accesos/proveedor-externo',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: formData
                };

                return axios(config);
            });

            Promise.all(accessPromises)
                .then(responses => {
                    console.log('✅ Acceso(s) registrado(s) exitosamente:', responses);

                    // Mostrar feedback de éxito
                    this.feedbackMessage = `¡Acceso registrado exitosamente! ${this.currentProvider.firstName} ${this.currentProvider.lastName} - ${this.selectedCompanies.length} empresa(s)`;
                    this.feedbackType = 'success';
                    this.showFeedback = true;

                    // También mostrar en snackbar global
                    this.$store.commit('snackbar_activate_true');
                    this.$store.commit('snackbar_change_message', this.feedbackMessage);

                    this.loadingProviderAccess = false;

                    // Limpiar formulario después de 3 segundos
                    setTimeout(() => {
                        this.resetProviderSearch();
                        this.inePhotoBase64 = '';
                        this.selectedProviderId = null;
                        this.selectedCompanies = [];
                        this.selectedService = null;
                    }, 3000);
                })
                .catch(error => {
                    console.error('Error registrando acceso:', error);

                    // Mostrar feedback de error
                    const errorMsg = error.response && error.response.data && error.response.data.mensaje
                        ? error.response.data.mensaje
                        : error.response && error.response.data && error.response.data.detail
                        ? error.response.data.detail
                        : error.message;

                    this.feedbackMessage = `Error al registrar acceso: ${errorMsg}`;
                    this.feedbackType = 'error';
                    this.showFeedback = true;

                    // También mostrar en snackbar global
                    this.$store.commit('snackbar_activate_true');
                    this.$store.commit('snackbar_change_message', this.feedbackMessage);

                    this.loadingProviderAccess = false;
                });
        }
    }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #002b48 #002b48 #002b48 #002b48;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }

    .camera-container-ine {
        position: relative;
        width: 100%;
        max-width: 300px;
        margin: 0 auto;
        background: #f5f5f5;
        border-radius: 8px;
        overflow: hidden;
        aspect-ratio: 4 / 3;
    }
</style>
